import { Component, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { AccountAccessService } from '@edgvr-front/account/feature/account-access';
import { EMPTY, mergeMap, take } from 'rxjs';

@Component({
  selector: 'edgvr-front-portal-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  constructor(
    private readonly accountAccessService: AccountAccessService,
    private readonly router: Router
  ) {}

  @HostListener('document:keydown.control.b', ['$event'])
  onCrtlBinaries(event: KeyboardEvent) {
    event.preventDefault();

    this.accountAccessService
      .accountAdminCompanyAccess()
      .pipe(
        take(1),
        mergeMap((_) => (_ ? this.router.navigate(['binaries']) : EMPTY))
      )
      .subscribe();
  }
}
